{
  "remove": "Supprimer"
}
